import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import {
  StyledH2,
  StyledNarrowWrapper,
  StyledText,
} from '../../../pages/UploadDocuments/UploadDocuments.styles';

const WaitForConfirmation = (): JSX.Element => {
  const { t } = useTranslation('documentsflow');

  return (
    <StyledNarrowWrapper>
      <StyledH2>{upperFirst(t('thanksForCompletingTheProcedure'))}</StyledH2>
      <StyledText black>{upperFirst(t('wellLetYouKnow'))}</StyledText>
    </StyledNarrowWrapper>
  );
};

export default WaitForConfirmation;
